import { render, staticRenderFns } from "./Promotional.vue?vue&type=template&id=34c4549e&scoped=true"
import script from "./Promotional.vue?vue&type=script&lang=js"
export * from "./Promotional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4549e",
  null
  
)

export default component.exports